module.exports = __webpack_public_path__ + "static/img/img-nolist.d0738383.png";